@if (displayedItems.length > 0) {
  <div id="compactList" class="list-container compact">
    @for (item of displayedItems; track $index) {
      <div class="item" [id]="item.name | removewhitespace | lowercase">
        <rdx-user-content-select-item
          [item]="item"
          [isSelected]="selectedItemIds | isIncluded: item.id"
          (itemSelected)="selectToggled.emit($event)"
        />
      </div>
    }
  </div>
}
